import { render, staticRenderFns } from "./JobReportsServicesTable.vue?vue&type=template&id=883c77ec&"
import script from "./JobReportsServicesTable.vue?vue&type=script&lang=js&"
export * from "./JobReportsServicesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports